import { useLayoutEffect, useState } from 'react';
import { NavigationProps } from './Props';
import { NavigationMobile } from './NavigationMobile';
import { NavigationFullPage } from './NavigationFullPage';

const calculateIsMobile = () => window.innerWidth < 1024;

export function Navigation(props: NavigationProps) {
  const [isMobile, setIsMobile] = useState(calculateIsMobile());
  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(calculateIsMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });
  if (!props.currentUser) return [];
  return isMobile ? (
    <NavigationMobile {...props} />
  ) : (
    <NavigationFullPage {...props} />
  );
}
